/* eslint-disable no-unused-vars */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import InputMask from 'react-input-mask';
import Modal from 'modules/common/components/Modal';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import useFormValidator from 'useFormValidator';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import Uploader from 'modules/common/components/Uploader';
import { customStyle } from 'helper';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateEmployeeModal({
  createUserManagement,
  getUserManagementList,
  history,
  showUserManagement,
  getRoleList,
  roleList,
  creating,
}) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    mobile_number: '',
    telephone_number: '',
    address: '',
    role_id: '',
    photo: '',
  });
  const validateForm = useFormValidator(formData, {
    photo: 'required',
    first_name: 'required',
    last_name: 'required',
    email: 'required|email',
    password: 'required|password',
    mobile_number: 'required|cellphone_number',
    address: 'required',
    role_id: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        photo: formData.photo.cdnUrl,
        is_active: 1,
      };

      createUserManagement(args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/user-management/employees/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
    if (!_.isObject(formData.photo)) {
      const args = {
        ...formData,
        is_active: 1,
      };

      createUserManagement(args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/user-management/employees/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const roleOptions = roleList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChangePhoto = (key) => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          <div className='col-4'>
            <label className="form-label">
              Profile Photo: {validateForm.renderMessage('photo')}
            </label>
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
            <FilePondSingleUpload onChange={onChangePhoto('photo')} />
          </div>
          <div className='col-8'>
            <div className="row">
              <div className="col-6 form-group">
                <label className="form-label">
                  First Name: {validateForm.renderMessage('first_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="first_name"
                  onChange={onChange}
                  value={_.get(formData, 'first_name')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Last Name: {validateForm.renderMessage('last_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="last_name"
                  onChange={onChange}
                  value={_.get(formData, 'last_name')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Email Address: {validateForm.renderMessage('email')}
                </label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  onChange={onChange}
                  value={_.get(formData, 'email')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Password: {validateForm.renderMessage('password')}
                </label>
                <input
                  className="form-control"
                  type="password"
                  name="password"
                  onChange={onChange}
                  value={_.get(formData, 'password')}
                  autoComplete="new-password"
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Mobile Number: {validateForm.renderMessage('mobile_number')}
                </label>
                <InputMask
                  className="form-control"
                  mask="999999999999"
                  alwaysShowMask
                  type="text"
                  name="mobile_number"
                  onChange={onChange}
                  value={_.get(formData, 'mobile_number')}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Telephone Number: {validateForm.renderMessage('telephone_number')}
                </label>
                <InputMask
                  className="form-control"
                  mask="999-999-9999"
                  alwaysShowMask
                  type="text"
                  name="telephone_number"
                  onChange={onChange}
                  value={_.get(formData, 'telephone_number')}
                />
              </div>
              <div className="col-12 form-group">
                <label className="form-label">
                  Address: {validateForm.renderMessage('address')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="address"
                  onChange={onChange}
                  value={_.get(formData, 'address')}
                />
              </div>
              <div className="col-12 form-group">
                <label className="form-label">
                  Role: {validateForm.renderMessage('role_id')}
                </label>
                <Select
                  styles={customStyle}
                  placeholder="Select Role"
                  onChange={handleOnChangeSelect('role_id')}
                  options={roleOptions}
                />
              </div>
            </div>
          </div>
        </div>
                
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateEmployeeModal.propTypes = {
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  createUserManagement: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  roleList: PropTypes.instanceOf(Array).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateEmployeeModal);
